<template>
  <div class="form-group">
    <label for="language-switcher">{{ $t("global.select_language") }}</label>
    <select
      id="language-switcher"
      v-model="$i18n.locale"
      @change="onLanguageChange"
      class="form-control form-group"
    >
      <template v-if="langs.length">
        <option v-for="lang in langs" :value="lang" :key="lang">{{ $t('languages.'+ lang) }}</option>
      </template>
    </select>
  </div>
</template>

<script>
import { languages } from "../../locales";

export default {
  name: "LanguageSwitcher",
  data() {
    return {
      langs: Object.keys(languages)
    };
  },
  methods: {
    onLanguageChange() {
      localStorage.setItem("automato_user_language", this.$i18n.locale);
    }
  }
};
</script>